const servicos = [
  {
    title: 'Box para Banheiros',
    subtitle: 'Padrão e Elegance',
    icon: 'ri-home-smile-line',
    img: 'https://readdy.ai/api/search-image?query=luxury%20bathroom%20glass%20shower%20box%20enclosure%20modern%20design%20elegant%20frameless%20premium%20finish%20white%20tiles%20clean%20minimal&width=600&height=500&seq=serv001&orientation=landscape',
  },
  {
    title: 'Fechamento de Sacadas',
    subtitle: 'Articuladas Sem Roldana',
    icon: 'ri-building-2-line',
    img: 'https://readdy.ai/api/search-image?query=luxury%20apartment%20balcony%20frameless%20glass%20enclosure%20articulated%20panels%20without%20rollers%20modern%20S%C3%A3o%20Paulo%20high%20rise%20premium%20finish%20open%20view&width=600&height=500&seq=serv002&orientation=landscape',
  },
  {
    title: 'Espelhos e Painéis',
    subtitle: 'Sob Medida',
    icon: 'ri-contrast-2-line',
    img: 'https://readdy.ai/api/search-image?query=custom%20mirror%20wall%20panel%20interior%20design%20luxury%20apartment%20modern%20minimal%20elegant%20large%20format%20glass%20reflection%20premium%20finish&width=600&height=500&seq=serv003&orientation=landscape',
  },
  {
    title: 'Guarda-corpos e Corrimãos',
    subtitle: 'Vidro Temperado e Laminado',
    icon: 'ri-shield-line',
    img: 'https://readdy.ai/api/search-image?query=glass%20railing%20guardrail%20staircase%20modern%20luxury%20apartment%20building%20transparent%20tempered%20glass%20premium%20hardware%20minimal%20design&width=600&height=500&seq=serv004&orientation=landscape',
  },
  {
    title: 'Fachadas Comerciais',
    subtitle: 'Eficiência Energética',
    icon: 'ri-store-2-line',
    img: 'https://readdy.ai/api/search-image?query=commercial%20glass%20facade%20modern%20office%20building%20S%C3%A3o%20Paulo%20energy%20efficient%20curtain%20wall%20frameless%20glass%20exterior%20architecture%20premium&width=600&height=500&seq=serv005&orientation=landscape',
  },
  {
    title: 'Divisórias e Portas',
    subtitle: 'Ambientes Internos',
    icon: 'ri-layout-column-line',
    img: 'https://readdy.ai/api/search-image?query=glass%20partition%20wall%20interior%20office%20home%20modern%20frameless%20sliding%20glass%20door%20divider%20minimal%20design%20premium%20finish%20elegant&width=600&height=500&seq=serv006&orientation=landscape',
  },
];

export default function Servicos() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            NOSSOS SERVIÇOS
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight">
            Nossas Soluções em Vidraçaria de Alto Padrão
          </h2>
          <p className="text-stone-500 mt-3 text-sm max-w-xl mx-auto">
            Da sacada ao banheiro, do espelho à fachada — a Thelux entrega excelência em cada detalhe.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {servicos.map((s) => (
            <div key={s.title} className="group relative rounded-2xl overflow-hidden h-[220px] md:h-[260px] cursor-pointer">
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-500/80 text-white mb-2">
                  <i className={`${s.icon} text-sm`}></i>
                </div>
                <h3 className="text-white font-bold text-base leading-tight">{s.title}</h3>
                <p className="text-white/70 text-sm mt-0.5">{s.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
